import { render, staticRenderFns } from "./btn-document-download.vue?vue&type=template&id=01e0d41d&scoped=true&"
import script from "./btn-document-download.vue?vue&type=script&lang=js&"
export * from "./btn-document-download.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01e0d41d",
  null
  
)

export default component.exports